@file:OptIn(InternalResourceApi::class)

package waifupics.modules.features.about.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/waifupics.modules.features.about.generated.resources/"

@delegate:ResourceContentHash(352_028_570)
internal val Res.string.a_simple_api_for_nekos: StringResource by lazy {
      StringResource("string:a_simple_api_for_nekos", "a_simple_api_for_nekos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 62),
      ))
    }

@delegate:ResourceContentHash(-1_560_661_297)
internal val Res.string.description_text: StringResource by lazy {
      StringResource("string:description_text", "description_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73, 332),
      ))
    }

@delegate:ResourceContentHash(1_318_117_448)
internal val Res.string.documentation: StringResource by lazy {
      StringResource("string:documentation", "documentation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 637, 41),
      ))
    }

@delegate:ResourceContentHash(-562_320_488)
internal val Res.string.documentation_text: StringResource by lazy {
      StringResource("string:documentation_text", "documentation_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 406, 230),
      ))
    }

@delegate:ResourceContentHash(1_123_576_598)
internal val Res.string.freecodecamp_url: StringResource by lazy {
      StringResource("string:freecodecamp_url", "freecodecamp_url", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 679, 172),
      ))
    }

@delegate:ResourceContentHash(1_445_892_428)
internal val Res.string.github: StringResource by lazy {
      StringResource("string:github", "github", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 852, 22),
      ))
    }

@delegate:ResourceContentHash(-644_671_141)
internal val Res.string.https_github_com_nekos_api_nekos_api: StringResource by lazy {
      StringResource("string:https_github_com_nekos_api_nekos_api", "https_github_com_nekos_api_nekos_api", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 875, 96),
      ))
    }

@delegate:ResourceContentHash(-641_430_276)
internal val Res.string.nekosapi: StringResource by lazy {
      StringResource("string:nekosapi", "nekosapi", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1014, 28),
      ))
    }

@delegate:ResourceContentHash(1_620_986_645)
internal val Res.string.nekosapi_logo: StringResource by lazy {
      StringResource("string:nekosapi_logo", "nekosapi_logo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 972, 41),
      ))
    }

@delegate:ResourceContentHash(723_026_710)
internal val Res.string.source_code: StringResource by lazy {
      StringResource("string:source_code", "source_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1305, 35),
      ))
    }

@delegate:ResourceContentHash(1_822_927_203)
internal val Res.string.source_code_link_text: StringResource by lazy {
      StringResource("string:source_code_link_text", "source_code_link_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1043, 261),
      ))
    }

@delegate:ResourceContentHash(215_325_628)
internal val Res.string.this_page: StringResource by lazy {
      StringResource("string:this_page", "this_page", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1341, 29),
      ))
    }

@delegate:ResourceContentHash(-539_245_967)
internal val Res.string.usage_text: StringResource by lazy {
      StringResource("string:usage_text", "usage_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1371, 254),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("a_simple_api_for_nekos", Res.string.a_simple_api_for_nekos)
  map.put("description_text", Res.string.description_text)
  map.put("documentation", Res.string.documentation)
  map.put("documentation_text", Res.string.documentation_text)
  map.put("freecodecamp_url", Res.string.freecodecamp_url)
  map.put("github", Res.string.github)
  map.put("https_github_com_nekos_api_nekos_api", Res.string.https_github_com_nekos_api_nekos_api)
  map.put("nekosapi", Res.string.nekosapi)
  map.put("nekosapi_logo", Res.string.nekosapi_logo)
  map.put("source_code", Res.string.source_code)
  map.put("source_code_link_text", Res.string.source_code_link_text)
  map.put("this_page", Res.string.this_page)
  map.put("usage_text", Res.string.usage_text)
}
